// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__SAlV1","description":"Skills_description__ZgKk+","skillsList":"Skills_skillsList__KaP8+"};